import React from 'react'
import { useSelector } from 'react-redux'
import { useRouteMatch } from 'react-router'
import classNames from 'classnames'

import { selectors as UISelectors } from 'data/ui'
import { Sidebar } from 'screens/Sidebar/Sidebar'
import { EnhancedTopBarRight } from 'screens/Topbar/TopBarRight'
import Metapanel from 'screens/Metapanel'

import { AppViewPortals } from './AppViewPortals'

const AppViewLayout: React.FC = ({ children }) => {
  const isMetaPanelOpen = Boolean(
    useRouteMatch(['/app/*/comments', '/app/*/outline'])
  )
  const isDetachedMode = useSelector(UISelectors.isDetachedModeEnabled)
  const isFocusMode = useSelector(UISelectors.isFocusModeEnabled)

  return (
    <div
      className={classNames('l-app-grid position-coverer slite-design-system', {
        'l-app-grid--focus': isDetachedMode || isFocusMode,
        'l-app-grid--meta': isMetaPanelOpen,
      })}
    >
      {!isDetachedMode && <Sidebar hidden={isMetaPanelOpen} />}
      {!isDetachedMode && <EnhancedTopBarRight />}
      {children}
      <Metapanel />
      <AppViewPortals />
    </div>
  )
}

export default React.memo(AppViewLayout)
